export const getIdFromRef = (ref: any) => ref?.id || ref
